export const ArrowLeft = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 9L4.5 6L7.5 3" stroke="#525866" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
